import { Manufacturer, ServicePriceService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useModelsByManufacturerQueryKey = 'useModelsByManufacturerQueryKey';

type ModelsByManufacturerProps = {
  manufacturerId: Manufacturer | undefined;
};

const fetchModelsByManufacturer = async ({ manufacturerId }: ModelsByManufacturerProps) => {
  if (!manufacturerId) return;
  const data = await ServicePriceService.getServicePriceGetModelByManufacturer(manufacturerId);
  return {
    data
  };
};

export const useModelsByManufacturerQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  input: ModelsByManufacturerProps,
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchModelsByManufacturer>>,
      QueryError,
      Awaited<ReturnType<typeof fetchModelsByManufacturer>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [fetchModelsByManufacturer, ...((queryKey as unknown as TQueryKey) ?? [{ ...input }])],
    () => fetchModelsByManufacturer(input),
    {
      ...options
    }
  );
